interface ErrorScreenProps {
  onRetry?: () => void
  title?: string
  message?: string
  /** Render contained within a page area instead of full-viewport. */
  inline?: boolean
  retryLabel?: string
}

export default function ErrorScreen({
  onRetry,
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Refresh to try again.',
  inline = false,
  retryLabel = 'Retry',
}: ErrorScreenProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: inline ? '60vh' : '100vh',
        padding: '24px',
        fontFamily: "'DM Sans', sans-serif",
        color: '#0F2E2A',
        background: inline ? 'transparent' : '#F7F5F0',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          fontSize: '48px',
          marginBottom: '16px',
        }}
      >
        ⚠️
      </div>
      <h1
        style={{
          fontSize: '22px',
          fontWeight: 600,
          margin: '0 0 8px',
        }}
      >
        {title}
      </h1>
      <p
        style={{
          fontSize: '14px',
          color: '#4A5568',
          margin: '0 0 24px',
          maxWidth: '420px',
        }}
      >
        {message}
      </p>
      <button
        type="button"
        onClick={onRetry ?? (() => window.location.reload())}
        style={{
          height: '40px',
          padding: '0 24px',
          borderRadius: '10px',
          border: 'none',
          background: '#0F2E2A',
          color: '#F3EFE6',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        {retryLabel}
      </button>
    </div>
  )
}
